import React, { useEffect, useState } from "react";
import { put } from "../../helpers/api_helper";
//redux
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Form, Input, Label, Row } from "reactstrap";
import Loader from "common/loader";
import { Trans } from "react-i18next";
import Breadcrumb from "components/Common/Breadcrumb";
import { UPDATE_ROLE } from "helpers/api_endpoints";

const EditRole = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [name, setName] = useState('');

    useEffect(() => {
        const screen = location.state;
        setId(screen.id);
        setName(screen.name);
        setLoading(false);
    }, []);

    const handleSubmit = () => {
        put(UPDATE_ROLE, { id, name })
            .then(response => {
                if (response.code == 200) {
                    navigate('/roles', { state: { successMsg: 'Updated SuccessFully' } });
                }
            })
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumb title="Roles" breadcrumbItem="Edit Role" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Name</Trans></Label>
                                                    <Input
                                                        name="title"
                                                        value={name}
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        type="text"
                                                        onChange={(e) => setName(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EditRole;